import React from 'react';
import { Box, Card, CardContent, CardHeader, Divider, InputAdornment, TextField } from '@material-ui/core';
import { getIn, useFormikContext } from 'formik';
import { ISettingsGroups } from '../interfaces';

interface IProps {
  disabled?: boolean;
}

const mrpInputProps = { min: 1, step: 1 };
const rateInputProps = { min: 0, max: 100, step: 0.01 };
const percentAdornment = { endAdornment: <InputAdornment position="end">%</InputAdornment> };

const CalculatorTariffSettings = ({ disabled }: IProps) => {
  const { values, errors, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [
      MONTHLY_CALCULATION_INDICATOR,
      TARIFF_MAINTENANCE_COST_SHARE,
      TARIFF_MANAGEMENT_SERVICE_RATE,
      TARIFF_VAT_RATE,
    ],
  } = values.settings[5];

  const field = (index: number) => `settings[5].settings[${index}].value`;
  const fieldError = (index: number): string | undefined => getIn(errors, field(index));

  // В массиве настройки идут по ключу, на экране — в порядке постановки; без ставок на бэкенде не падаем
  const rates = [
    { setting: TARIFF_VAT_RATE, index: 3 },
    { setting: TARIFF_MANAGEMENT_SERVICE_RATE, index: 2 },
    { setting: TARIFF_MAINTENANCE_COST_SHARE, index: 1 },
  ].filter(({ setting }) => Boolean(setting));

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent component={Box} sx={{ display: 'flex', flexDirection: 'column', gridGap: 16 }}>
        <TextField
          type="number"
          variant="filled"
          label={MONTHLY_CALCULATION_INDICATOR.description}
          value={MONTHLY_CALCULATION_INDICATOR.value}
          disabled={disabled}
          inputProps={mrpInputProps}
          error={Boolean(fieldError(0))}
          helperText={fieldError(0)}
          onChange={(event) => setFieldValue(field(0), event.target.value)}
          fullWidth
        />

        {rates.map(({ setting, index }) => (
          <TextField
            key={setting.key}
            type="number"
            variant="filled"
            label={setting.description}
            value={setting.value}
            disabled={disabled}
            inputProps={rateInputProps}
            InputProps={percentAdornment}
            error={Boolean(fieldError(index))}
            helperText={fieldError(index)}
            onChange={(event) => setFieldValue(field(index), event.target.value)}
            fullWidth
          />
        ))}
      </CardContent>
    </Card>
  );
};

export default CalculatorTariffSettings;
